/**
 * S-91: route lazy 分割の chunk 取得失敗を 1 回だけの自動リロードで回復する。
 *
 * Firebase Hosting はデプロイで旧 release のハッシュ付き chunk を配信しなくなり、
 * SPA rewrite（`**` → /index.html）が旧 chunk URL に 200 text/html を返すため、
 * デプロイを跨いで開きっぱなしのタブから未訪問の lazy ページへ遷移すると dynamic import
 * が MIME エラーで失敗する。React.lazy は失敗を恒久キャッシュするため、リロード以外に
 * 復帰手段がない（index.html は no-cache なのでリロードで新ハッシュに追従できる）。
 *
 * - Vite 5+ が動的 import の preload 失敗時に発火する `vite:preloadError` を捕捉
 * - 直近 30 秒以内にこのガードでリロード済みなら何もしない（hosting 自体の障害時の
 *   無限リロード防止。その場合はエラーを表面化させ既存のエラー処理に委ねる）
 */
const RELOADED_AT_KEY = 'kawai:chunk-reload-at';
const RELOAD_LOOP_GUARD_MS = 30 * 1000;
/** プライベートブラウジング等で sessionStorage アクセス自体が throw する環境に備える。 */
function getSessionStorage() {
    try {
        return window.sessionStorage;
    }
    catch {
        return null;
    }
}
export function installChunkReloadGuard() {
    window.addEventListener('vite:preloadError', (event) => {
        const store = getSessionStorage();
        // storage 不能環境では 30 秒ループガードを諦め、chunk 失敗ごとに 1 回リロードする
        // （React.lazy の恒久失敗より、稀なリロードの方が UX 上マシ）。
        const last = store ? Number(store.getItem(RELOADED_AT_KEY) ?? '0') : 0;
        if (Date.now() - last < RELOAD_LOOP_GUARD_MS)
            return;
        try {
            store?.setItem(RELOADED_AT_KEY, String(Date.now()));
        }
        catch {
            // 記録できなくてもリロード自体は行う
        }
        // preventDefault で React.lazy へのエラー伝播（恒久キャッシュ）を抑止してからリロード。
        event.preventDefault();
        window.location.reload();
    });
}
//# sourceMappingURL=chunkReloadGuard.js.map